export { default } from './SectionGoal';